import fetch from 'isomorphic-fetch';
import API_URL from 'helpers/apiURL';

/* ----------------------- List ----------------------- */
export const requested = () => ({ type: 'MAINTENANCE_PLAN_REQUESTED' });

export const request = (
  { vehicle_id, engine_id, transmission_id, traction_id, chassis },
  licensePlate,
  brandId
) => {
  return function(dispatch) {
    dispatch(requested());

    return fetch(
      `${API_URL}/maintenancePlans?brand_id=${brandId}&vehicle_id=${vehicle_id}&engine_id=${engine_id}&transmission_id=${transmission_id}&traction_id=${traction_id}&license_plate=${licensePlate}&chassis=${chassis}`
    )
      .then(response => response.json())
      .then(json => dispatch(maintenancePlanReceived(json)));
  };
};

export const maintenancePlanReceived = ({ data }) => {
  return {
    type: 'MAINTENANCE_PLAN_CRECEIVED',
    payload: data,
  };
};

export const maintenancePlanFailed = () => ({
  type: 'MAINTENANCE_PLAN_FAILED',
});
